import React, { ReactNode, useEffect, useRef } from 'react'
import styled from 'styled-components'

import breakpoints from '../../constants/breakpoints'

interface Props {
  children: ReactNode | ReactNode[]
}

const Slide: React.FC<Props> = ({ children }) => {
  const slideRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      const topHeader = document.querySelector('#top-header')
      const progressHeader = document.querySelector('#progress-header')

      const scrollPosition = slideRef.current?.scrollTop ?? 0
      if (scrollPosition > 0) {
        topHeader?.classList.add('scrolled')
        progressHeader?.classList.add('scrolled')
      } else {
        topHeader?.classList.remove('scrolled')
        progressHeader?.classList.remove('scrolled')
      }
    }

    slideRef.current?.addEventListener('scroll', handleScroll)

    return () => {
      slideRef.current?.removeEventListener('scroll', handleScroll)
    }
  }, [])

  let smallScreen = window.innerHeight < 300

  window.addEventListener('resize', () => {
    return (smallScreen = window.innerHeight < 300)
  })

  return (
    <SlideContainer id="readspeakerArea" tabIndex={-1} $smallScreen={smallScreen} ref={slideRef}>
      {children}
    </SlideContainer>
  )
}

const SlideContainer = styled.div<{ $smallScreen: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;

  ${({ $smallScreen }) =>
    $smallScreen &&
    `
      position: relative;
    `}

  &::before {
    content: '';
    width: 100%;
    height: 80px;
    position: absolute;
    top: 0;
    pointer-events: none;

    @media (min-width: ${breakpoints.sm}) {
      display: none;
      background-image: none;
    }
  }
`

export default Slide
